export const TEST_ID = 'criticalStatusBadge';
